/**
 * Componente para mostrar la barra de progreso de rangos en el header
 */

if ( typeof RangoProgressHeader !== 'function' ) {

	class RangoProgressHeader extends HTMLElement {
		
		constructor() {
			super();
			this.init();
		}

		init() {
			// Escuchar evento cart-updated tanto en document como en cart-form
			document.addEventListener('cart-updated', () => {
				this.updateProgress();
			}, true); // Usar capture phase para capturar eventos que no burbujean
			
			// También escuchar directamente en el cart-form si existe
			const cartForm = document.getElementById('AjaxCartForm');
			if (cartForm) {
				cartForm.addEventListener('cart-updated', () => {
					this.updateProgress();
				});
			}
			
			// Observar cuando se añade un nuevo cart-form al DOM
			const observer = new MutationObserver(() => {
				const cartForm = document.getElementById('AjaxCartForm');
				if (cartForm && !cartForm.hasAttribute('data-progress-listener')) {
					cartForm.setAttribute('data-progress-listener', 'true');
					cartForm.addEventListener('cart-updated', () => {
						this.updateProgress();
					});
				}
			});
			
			observer.observe(document.body, {
				childList: true,
				subtree: true
			});
			
			document.addEventListener('add-to-cart', async () => {
				if (typeof window.RangosSystem !== 'undefined') {
					await new Promise(resolve => setTimeout(resolve, 500));
					await window.RangosSystem.loadCart();
					this.updateProgress();
				}
			});
			
			setTimeout(() => this.updateProgress(), 1500);
			
			// Controlar visibilidad del texto según el scroll
			this.lastScrollY = window.scrollY;
			this.scrollingDown = false;
			this.handleScroll = this.handleScroll.bind(this);
			window.addEventListener('scroll', this.handleScroll, { passive: true });
		}
		
		handleScroll() {
			const currentScrollY = window.scrollY;
			const textEl = this.querySelector('[data-rango-progress-text]');
			
			if (!textEl) return;
			
			// Si está en el top de la página, mostrar el texto
			if (currentScrollY <= 10) {
				textEl.classList.remove('rango-progress-header__text--hidden');
				this.classList.remove('rango-progress-header--text-hidden');
				this.scrollingDown = false;
				this.lastScrollY = currentScrollY;
				return;
			}
			
			// Verificar si estamos al final de la página
			const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
			const isAtBottom = currentScrollY >= maxScroll - 5; // 5px de tolerancia
			
			// Si estamos al final, mantener el estado actual y no hacer cambios
			if (isAtBottom) {
				return;
			}
			
			// Threshold para evitar cambios por fluctuaciones mínimas
			const scrollDelta = Math.abs(currentScrollY - this.lastScrollY);
			if (scrollDelta < 2) {
				return; // Ignorar cambios menores a 2px
			}
			
			// Detectar dirección del scroll
			if (currentScrollY > this.lastScrollY && currentScrollY > 50) {
				// Scroll hacia abajo
				if (!this.scrollingDown) {
					this.scrollingDown = true;
					textEl.classList.add('rango-progress-header__text--hidden');
					this.classList.add('rango-progress-header--text-hidden');
				}
			} else if (currentScrollY < this.lastScrollY) {
				// Scroll hacia arriba
				if (this.scrollingDown) {
					this.scrollingDown = false;
					textEl.classList.remove('rango-progress-header__text--hidden');
					this.classList.remove('rango-progress-header--text-hidden');
				}
			}
			
			this.lastScrollY = currentScrollY;
		}

		async updateProgress() {
			if (typeof window.RangosSystem === 'undefined') {
				return;
			}
			
			await window.RangosSystem.loadCart();
			const progreso = window.RangosSystem.obtenerProgreso();
			const threshold = window.RangosSystem.THRESHOLD_CENTS;
			
			const fills = {
				r1: this.querySelector('[data-rango-progress-fill="1"]'),
				r2: this.querySelector('[data-rango-progress-fill="2"]'),
				r3: this.querySelector('[data-rango-progress-fill="3"]')
			};
			const textEl = this.querySelector('[data-rango-progress-text]');
			
			if (!fills.r1 || !fills.r2 || !fills.r3 || !textEl) return;
			
			const subtotalR1 = window.RangosSystem.subtotalPorRango(1);
			const subtotalR2 = window.RangosSystem.subtotalPorRango(2);
			const subtotalR1Euros = (subtotalR1 / 100).toFixed(0);
			const subtotalR2Euros = (subtotalR2 / 100).toFixed(0);
			
			// Actualizar barras de progreso
			if (progreso.rango3.desbloqueado) {
				fills.r1.style.width = '100%';
				fills.r2.style.width = '100%';
				fills.r3.style.width = '100%';
				textEl.textContent = 'Rango 3 • Nivel máximo • Acceso a todos los productos';
			} else if (progreso.rango2.desbloqueado) {
				const porcentajeR2 = Math.min(100, (subtotalR2 / threshold) * 100);
				const faltante = 300 - parseFloat(subtotalR2Euros);
				fills.r1.style.width = '100%';
				fills.r2.style.width = `${porcentajeR2}%`;
				fills.r3.style.width = '0%';
				textEl.textContent = `Rango 2: ${subtotalR2Euros}€ / 300€ • Faltan ${faltante.toFixed(0)}€ para Rango 3`;
			} else {
				const porcentajeR1 = Math.min(100, (subtotalR1 / threshold) * 100);
				const faltante = 300 - parseFloat(subtotalR1Euros);
				fills.r1.style.width = `${porcentajeR1}%`;
				fills.r2.style.width = '0%';
				fills.r3.style.width = '0%';
				textEl.textContent = `Rango 1: ${subtotalR1Euros}€ / 300€ • Faltan ${faltante.toFixed(0)}€ para Rango 2`;
			}
			
			// Mostrar siempre la barra
			this.style.display = 'block';
			setTimeout(() => {
				document.body.classList.add('has-rango-progress');
			}, 50);
		}
	}

	if ( typeof customElements.get('rango-progress-header') == 'undefined' ) {
		customElements.define('rango-progress-header', RangoProgressHeader);
	}

}

